var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { UserCreditBilling } from '../../../models/Billing/user-credit-billing';
import { UserCredits } from '../../../models/Billing/user-credits';
import { ActivityPricing } from '../../../models/Billing/activity-pricing';
import { BillingDetails } from '../../../models/Billing/billing-details';
import { Invoice } from '../../../models/Billing/invoice';
import { apiEndpoints, CommonConstant } from '../../app.constants';
import { DateUtils } from '../../utils/date.utils';
export var ActivityPricingType;
(function (ActivityPricingType) {
    ActivityPricingType["DISCOVER"] = "discover";
    ActivityPricingType["INFLUENCER"] = "influencers";
    ActivityPricingType["CAMPAIGN"] = "campaigns";
    ActivityPricingType["PROFILE"] = "profile";
    ActivityPricingType["REPORT_EXPORT"] = "report export";
    ActivityPricingType["MONITORING"] = "monitoring";
})(ActivityPricingType || (ActivityPricingType = {}));
var CreditBaseBillingService = /** @class */ (function (_super) {
    __extends(CreditBaseBillingService, _super);
    function CreditBaseBillingService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userCreditBilling = new UserCreditBilling();
        return _this;
    }
    Object.defineProperty(CreditBaseBillingService.prototype, "isLoadedUserCreditData", {
        get: function () {
            return this.userCreditBilling.userCredit !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditBaseBillingService.prototype, "userCredit", {
        get: function () {
            if (!this.userCreditBilling.userCredit) {
                return new UserCredits();
            }
            return this.userCreditBilling.userCredit;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditBaseBillingService.prototype, "activityPricing", {
        get: function () {
            if (!this.userCreditBilling.activityPricing) {
                return new ActivityPricing();
            }
            return this.userCreditBilling.activityPricing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditBaseBillingService.prototype, "listCreditUsage", {
        get: function () {
            if (!this.userCreditBilling.listCreditUsage) {
                return [];
            }
            return this.userCreditBilling.listCreditUsage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditBaseBillingService.prototype, "billingDetails", {
        get: function () {
            if (!this.userCreditBilling.billingDetails) {
                return new BillingDetails();
            }
            return this.userCreditBilling.billingDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreditBaseBillingService.prototype, "listInvoice", {
        get: function () {
            if (!this.userCreditBilling.listInvoice) {
                return [];
            }
            return this.userCreditBilling.listInvoice;
        },
        enumerable: true,
        configurable: true
    });
    CreditBaseBillingService.prototype.loadUserCreditBilling = function (companyId) {
        var _this = this;
        return this.get(apiEndpoints.creditBilling.replace(':companyId', companyId)).subscribe(function (res) {
            var creditBillingData = res.data;
            // get user credit
            var userCredit = new UserCredits({
                accountLevel: creditBillingData.accountLevel,
                pricePerCredit: creditBillingData.pricePerCredit,
                currency: creditBillingData.currency,
                availableCredits: creditBillingData.availableCredits,
                currentMonthUsedCredits: creditBillingData.currentMonthUsedCredits
            });
            _this.userCreditBilling.userCredit = userCredit;
            // get activity pricing
            _this.userCreditBilling.activityPricing = new ActivityPricing();
            creditBillingData.activityPricingList.forEach(function (activity) { return _this.classifyActivityPricing(activity); });
            _this.userCreditBilling.listCreditUsage = creditBillingData.dailyUsageList.map(function (usage) { return Object.assign({}, usage, {
                date: _this.formatBillingDate(usage.date)
            }); });
            _this.userCreditBilling.billingDetails = creditBillingData.billingDetails;
            _this.userCreditBilling.listInvoice = [];
            creditBillingData.invoices.forEach(function (invoice, index) {
                _this.userCreditBilling.listInvoice.push(new Invoice(_this.getInvoiceNumber(invoice.invoiceNumber, index), _this.getInvoicePdfUrl(invoice.file, invoice.invoiceNumber, index), invoice.file.id, invoice.file.contentType, _this.formatBillingDate(invoice.invoiceDate), _this.formatBillingDate(invoice.dueDate), invoice.amount, invoice.currency, invoice.status));
            });
        });
    };
    CreditBaseBillingService.prototype.formatBillingDate = function (dateStr) {
        var date = new Date(dateStr);
        var year = date.getFullYear();
        var dayMonth = DateUtils.formatDate(dateStr, { day: 'numeric', month: 'short' }, CommonConstant.US_LOCALE);
        return dayMonth + ", " + year;
    };
    CreditBaseBillingService.prototype.getInvoicePdfUrl = function (invoiceFile, invoiceNumber, index) {
        if (!invoiceFile) {
            return null;
        }
        var formattedInvoiveNumber = this.getInvoiceNumber(invoiceNumber, index);
        return invoiceFile.diskFileName + ("&response-content-disposition=attachment%3B%20filename=%22" + formattedInvoiveNumber + ".pdf%22");
    };
    CreditBaseBillingService.prototype.getInvoiceNumber = function (invoiceNumber, index) {
        if (invoiceNumber) {
            return invoiceNumber;
        }
        // just a temporal solution, because, the invoice number is not defined yet on webservice
        // will be removed later
        return "INV_" + (index + 1);
    };
    CreditBaseBillingService.prototype.classifyActivityPricing = function (activityPricing) {
        var activityName = activityPricing.creditPackageActivity.name.toLowerCase();
        switch (activityName) {
            case ActivityPricingType.DISCOVER:
                this.userCreditBilling.activityPricing.discovery = activityPricing.numberOfCredits;
                break;
            case ActivityPricingType.INFLUENCER:
                this.userCreditBilling.activityPricing.influencers = activityPricing.numberOfCredits;
                break;
            case ActivityPricingType.CAMPAIGN:
                this.userCreditBilling.activityPricing.campaigns = activityPricing.numberOfCredits;
                break;
            case ActivityPricingType.PROFILE:
                this.userCreditBilling.activityPricing.profiles = activityPricing.numberOfCredits;
                break;
            case ActivityPricingType.REPORT_EXPORT:
                this.userCreditBilling.activityPricing.exportReport = activityPricing.numberOfCredits;
                break;
            case ActivityPricingType.MONITORING:
                this.userCreditBilling.activityPricing.monitoring = activityPricing.numberOfCredits;
                break;
        }
    };
    CreditBaseBillingService.prototype.saveOrUpdateCreditBilling = function (billingDetails, companyId) {
        var data = Object.assign({}, billingDetails, {
            companyId: companyId
        });
        return this.post(apiEndpoints.updateBillingDetails, data);
    };
    return CreditBaseBillingService;
}(BackendHttpService));
export { CreditBaseBillingService };



// WEBPACK FOOTER //
// ./src/app/services/credit-based-billing/credit-base-billing.service.ts.pre-build-optimizer.js